import { Checkbox } from "primereact/checkbox"
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch"
import { useMapURLParams } from "../../../../../../hooks/map/useMapParams"
import { useMapSlice } from "../../../../../../stateManagement/hooks/useMapSlice"
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions"
import { classNames } from "primereact/utils"
import { Calendar } from "primereact/calendar"
import { configureCalendarFormattedValue, patchFilterCalendarState } from "./filterCalendarFunctions"
import { MapCalendarFilter } from "../types"
import { formatToDateObject } from "../../../../../../shared/format/date"

type FilterCalendarProps = {
    filterConfig: MapCalendarFilter
}

export default function FilterCalendar({ filterConfig }: FilterCalendarProps) {
    const dispatchMap = useMapDispatch()
    const { canBeIgnored, canIncludeNull, fieldName, operation, option } = filterConfig ?? {}
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };;
    const mapState = useMapSlice(mapName)
    const { mapFiltersState }: any = mapState ?? {};
    const filterState = mapFiltersState?.[fieldName]
    const { isIgnored, includeNull, hintText, minDate, maxDate, minValue, maxValue, value } = filterState ?? {}
    const formattedValue = configureCalendarFormattedValue(minValue, maxValue, value)
    const formattedMinDate = formatToDateObject(minDate) as Date
    const formattedMaxDate = formatToDateObject(maxDate) as Date
    const ignoreInputId = `ignore-${fieldName}`
    const nullInputId = `null-${fieldName}`

    const selectionMode = operation === 'between' ? 'range' : 'single'

    const calendarContainerClassNames = classNames({
        "calendar": true,
        "filter-ignore": isIgnored
    })

    const IsIgnoredValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={ignoreInputId}
                name={ignoreInputId}
                onChange={(event: any) => patchFilterCalendarState(mapName, fieldName, { isIgnored: event.checked }, dispatchMap)}
                checked={isIgnored}
            />
            <label htmlFor={ignoreInputId} className="ms-2">Не учитывать</label>
        </div>
    )

    const IncludeNullValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={nullInputId}
                name={nullInputId}
                onChange={(event: any) => patchFilterCalendarState(mapName, fieldName, { includeNull: event.checked }, dispatchMap)}
                checked={includeNull}
            />
            <label htmlFor={nullInputId} className="ms-2">Не указан</label>
        </div>
    )

    function onChangeCalendarValue(value: Date | [Date, Date] | [Date, null]) {
        if (Array.isArray(value)) {
            const [minValue, maxValue] = value
            patchFilterCalendarState(mapName, fieldName, { minValue, maxValue }, dispatchMap)
        } else {
            patchFilterCalendarState(mapName, fieldName, { value }, dispatchMap)
        }
    }

    return (
        <div className="filter-calendar">
            {canBeIgnored && <IsIgnoredValueCheckbox />}
            {canIncludeNull && <IncludeNullValueCheckbox />}
            <div className={calendarContainerClassNames}>
                <Calendar
                    value={formattedValue}
                    onChange={(event: any) => onChangeCalendarValue(event.value)}
                    inline
                    selectOtherMonths
                    selectionMode={selectionMode}
                    minDate={formattedMinDate}
                    maxDate={formattedMaxDate}
                    // view={option}
                    readOnlyInput
                />
                {operation === "between" &&
                    <div className="show-date-filter-div">
                        <div className="date-filter-text">{hintText}</div>
                    </div>
                }
            </div>
            {/* {presetValues &&
                <div className={"preset-values-buttons-div" + (ignoreFilterValue?.checked ? " filter-ignore" : '')}>
                    {filterType === "between" &&
                        <>
                            {presetValues.map((presetValue: any) => {
                                const { filterRangeValues, activeStyleFunction } = presetRangeValuesButtonsOptions[presetValue?.type]
                                return (
                                    <Button
                                        className="preset-values-button"
                                        onClick={() => setFilterCalendarRangeValues(filterRangeValues)}
                                        outlined={!activeStyleFunction([minValue, maxValue])}
                                    >
                                        {presetValue?.caption}
                                    </Button>
                                )
                            })}
                        </>
                    }
                </div>
            } */}
        </div>
    )
}
